module.exports = __webpack_public_path__ + "static/media/AINQA.291d8a53.png";